import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as typography from "@styles/typography.module.css";
import classNames from "classnames";
import * as styles from "./baseHomeSection.module.css";
const BaseHomeSection = ({ id, title, children, }) => {
    return (_jsxs("section", { id: id, className: styles.baseHomeSection, children: [_jsx("h2", { className: classNames(typography.header2, typography.radialGradientText), children: title }), children] }));
};
export default BaseHomeSection;
